<template>
  <v-app>
    <v-container grid-list-md>
      <v-layout row wrap>
      <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>
        <v-flex xs4>
          <statTile url='/computerAssets' :readyData='computerReady' :recycleData='computerRecycled' :data='computerTotal' icon='computer' title='Desktops/Laptops'/>
        </v-flex>
        <v-flex xs4 >
          <statTile url='/monitorAssets' :readyData='monitorsReady' :recycleData='monitorsRecycle' :data='monitorsTotal' icon='desktop_mac' title='Monitors'/>
        </v-flex>
        <v-flex xs4 >
          <statTile url='/phoneAssets' :readyData='phonesReady' :recycleData='phonesRecycle' :data='phonesTotal' icon='smartphone' title='Phones'/>
        </v-flex>
             <v-flex xs6>
       <v-card>
         <h2 class='title'>Assets Type</h2>
      <pie-chart :data="[['Computers', computerTotal], ['Monitors', monitorsTotal],['Cell Phones', phonesTotal]]"></pie-chart>
      </v-card>
      </v-flex>
      <v-flex xs6>
       <v-card>
         <h2 class='title'>Assets Status</h2>
      <column-chart :data="[['Ready',assetReady], ['Recycled', assetRecycle], ['Shipped', assetShipped]]"></column-chart>
      </v-card>
      </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
// @ is an alias to /src
const fb = require("../firebaseConfig.js");
import statTile from '../components/dashboardComp/StatTiles'
export default {
  name: 'home',
  mounted(){
      fb.IndexCollections.doc("AssetsIndex")
      .onSnapshot(docs => {
        this.computerTotal = docs.data().total_computers
        this.monitorsTotal = docs.data().total_monitors
        this.phonesTotal = docs.data().total_cellphones
        this.assetReady = docs.data().ready_monitors + docs.data().ready_computers + docs.data().ready_cellphones
        this.assetRecycle = docs.data().recycled_monitors + docs.data().recycled_computers + docs.data().recycled_cellphones
        this.computerRecycled = docs.data().recycled_computers
        this.monitorsRecycle = docs.data().recycled_monitors
        this.phonesRecycle = docs.data().recycled_cellphones
        this.computerReady = docs.data().ready_computers
        this.monitorsReady = docs.data().ready_monitors
        this.phonesReady = docs.data().ready_cellphones
      });
  },
  components: {
      statTile
  },
  data(){ 
    return{
      computerReady : 0,
      monitorsReady : 0,
      phonesReady : 0,
       assetReady : 0,
       assetRecycle : 0,
       assetShipped : 0,
       computerRecycled : 0,
       monitorsRecycle : 0,
       phonesRecycle : 0,
       computerTotal : 0,
       monitorsTotal : 0,
       phonesTotal : 0,
       items: [
        {
          text: 'Home',
          disabled: true,
          to: 'home'
        },
   
      ],
    }
  }
}
</script>
